/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Empty_FilterInputs */

const cs_pm_empty_filter = /** @type {(inputs: Pm_Empty_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nic tu není.`)
};

const en_pm_empty_filter = /** @type {(inputs: Pm_Empty_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing here.`)
};

/**
* | output |
* | --- |
* | "Nothing here." |
*
* @param {Pm_Empty_FilterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_empty_filter = /** @type {((inputs?: Pm_Empty_FilterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Empty_FilterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_empty_filter(inputs)
	return cs_pm_empty_filter(inputs)
});